import { SchedulerBulkUpdateRequest, SchedulerEntry, SchedulerFilters } from '@/types/scheduler.types';
import { ApiResponse } from '@/types/services';

import { baseApi } from './base-api';
import { buildQueryParams } from './helpers';

export type GetSchedulerEntriesResponse = ApiResponse<SchedulerEntry[]>;

export const shedularApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getSchedulerEntries: builder.query<SchedulerEntry[], SchedulerFilters>({
      query: filters => {
        const queryString = buildQueryParams(filters);
        return { url: `scheduler${queryString ? `?${queryString}` : ''}` };
      },
      providesTags: ['SchedulerEntries'],
      transformResponse: (response: GetSchedulerEntriesResponse): SchedulerEntry[] => {
        return response.data || [];
      }
    }),
    bulkUpdateSchedulerItems: builder.mutation({
      query: (body: SchedulerBulkUpdateRequest) => ({
        url: `scheduler/bulk-update`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['SchedulerEntries']
    }),
    triggerProcessing: builder.mutation({
      query: () => ({ url: `scheduler/trigger-processing`, method: 'POST' }),
      invalidatesTags: ['SchedulerEntries']
    })
  })
});
export const { useGetSchedulerEntriesQuery, useBulkUpdateSchedulerItemsMutation, useTriggerProcessingMutation } =
  shedularApi;
